import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Measurements() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [measurements, setMeasurements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [formData, setFormData] = useState({
    bust: '', waist: '', hips: '', height: '', shoe_size: '',
    shoulder_width: '', arm_length: '', leg_length: '', dress_size: '',
    notes: ''
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('crm_token');
      const [customersRes, measurementsRes] = await Promise.all([
        fetch('/api/customers?limit=1000', { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch('/api/measurements', { headers: { 'Authorization': `Bearer ${token}` } })
      ]);
      
      const customersData = await customersRes.json();
      const measurementsData = await measurementsRes.json();
      
      setCustomers(customersData.data || []);
      setMeasurements(measurementsData.measurements || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('crm_token');
      const res = await fetch('/api/measurements', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ customer_id: selectedCustomer.id, ...formData })
      });
      
      if (res.ok) {
        setShowModal(false);
        fetchData();
        setFormData({ bust: '', waist: '', hips: '', height: '', shoe_size: '', shoulder_width: '', arm_length: '', leg_length: '', dress_size: '', notes: '' });
      }
    } catch (error) {
      console.error('Error saving measurement:', error);
    }
  };

  const getCustomerName = (id) => {
    const customer = customers.find(c => c.id === id);
    return customer ? `${customer.first_name} ${customer.last_name}` : '-';
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h1>Ölçü Kartı</h1>
        <button className="btn-primary" onClick={() => setShowModal(true)}>+ Yeni Ölçü Ekle</button>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Müşteri</th>
              <th>Göğüs</th>
              <th>Bel</th>
              <th>Kalça</th>
              <th>Boy</th>
              <th>Elbise Beden</th>
              <th>Notlar</th>
            </tr>
          </thead>
          <tbody>
            {measurements.length === 0 ? (
              <tr><td colSpan="7" style={{textAlign:'center'}}>Henüz ölçü kartı yok</td></tr>
            ) : measurements.map(m => (
              <tr key={m.id}>
                <td>{getCustomerName(m.customer_id)}</td>
                <td>{m.bust}</td>
                <td>{m.waist}</td>
                <td>{m.hips}</td>
                <td>{m.height}</td>
                <td>{m.dress_size}</td>
                <td>{m.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Yeni Ölçü Kartı</h2>
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label>Müşteri</label>
                <select onChange={e => {
                  const c = customers.find(cust => cust.id === parseInt(e.target.value));
                  setSelectedCustomer(c);
                }} required>
                  <option value="">Seçiniz</option>
                  {customers.map(c => (
                    <option key={c.id} value={c.id}>{c.first_name} {c.last_name}</option>
                  ))}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Göğüs</label><input type="text" value={formData.bust} onChange={e => setFormData({...formData, bust: e.target.value})} /></div>
                <div className="form-group"><label>Bel</label><input type="text" value={formData.waist} onChange={e => setFormData({...formData, waist: e.target.value})} /></div>
                <div className="form-group"><label>Kalça</label><input type="text" value={formData.hips} onChange={e => setFormData({...formData, hips: e.target.value})} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Boy</label><input type="text" value={formData.height} onChange={e => setFormData({...formData, height: e.target.value})} /></div>
                <div className="form-group"><label>Ayakkabı No</label><input type="text" value={formData.shoe_size} onChange={e => setFormData({...formData, shoe_size: e.target.value})} /></div>
                <div className="form-group"><label>Elbise Beden</label><input type="text" value={formData.dress_size} onChange={e => setFormData({...formData, dress_size: e.target.value})} /></div>
              </div>
              <div className="form-group"><label>Notlar</label><textarea value={formData.notes} onChange={e => setFormData({...formData, notes: e.target.value})} /></div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
                <button type="submit" className="btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style>{`
        .page { padding: 24px; }
        .page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; }
        .page-header h1 { font-size: 24px; font-weight: 700; color: #FFFFFF; margin: 0; }
        .table-container { background: rgba(17,17,24,0.7); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px; overflow: hidden; backdrop-filter: blur(12px); }
        .table { width: 100%; border-collapse: collapse; }
        .table th, .table td { padding: 14px 16px; text-align: left; border-bottom: 1px solid rgba(255,255,255,0.05); color: #E5E7EB; }
        .table th { background: rgba(26,26,36,0.6); font-weight: 600; color: #9CA3AF; font-size: 13px; }
        .table tr:hover { background: rgba(59,130,246,0.05); }
        .btn-primary { background: linear-gradient(135deg, #3B82F6, #2563EB); color: white; border: none; padding: 10px 20px; border-radius: 10px; cursor: pointer; font-weight: 600; box-shadow: 0 4px 12px rgba(59,130,246,0.3); transition: all 0.2s; }
        .btn-primary:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(59,130,246,0.4); }
        .btn-secondary { background: rgba(255,255,255,0.06); color: #E5E7EB; border: 1px solid rgba(255,255,255,0.1); padding: 10px 20px; border-radius: 10px; cursor: pointer; font-weight: 500; }
        .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.75); backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; z-index: 1000; }
        .modal { background: rgba(17,17,24,0.95); border: 1px solid rgba(255,255,255,0.1); padding: 24px; border-radius: 20px; width: 500px; max-height: 90vh; overflow-y: auto; box-shadow: 0 24px 48px rgba(0,0,0,0.6); backdrop-filter: blur(40px); }
        .modal h2 { margin: 0 0 20px; font-size: 20px; color: #FFFFFF; }
        .form-group { margin-bottom: 16px; }
        .form-group label { display: block; margin-bottom: 6px; font-weight: 500; color: #E5E7EB; }
        .form-group input, .form-group select, .form-group textarea { width: 100%; padding: 10px 12px; border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; font-size: 14px; background: rgba(26,26,36,0.8); color: #FFFFFF; }
        .form-group select option { background: #111118; }
        .form-group textarea { min-height: 80px; }
        .form-row { display: flex; gap: 12px; }
        .form-row .form-group { flex: 1; }
        .modal-actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px; }
        .loading { display: flex; align-items: center; justify-content: center; height: 100vh; color: #60A5FA; font-size: 18px; }
      `}</style>
    </div>
  );
}

export default Measurements;
